import { Button } from 'antd';

/**
 * Reusable Form Action Buttons Component
 */
export const FormActionButtons = ({
    isEditMode,
    isSubmitting,
    onToggleEdit,
    onPrint
}) => {
    return (
        <div style={{
            marginTop: '24px',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '12px',
            paddingTop: '24px',
            borderTop: '2px solid #f0f0f0'
        }}>
            <Button
                size="large"
                onClick={onToggleEdit}
                style={{
                    borderRadius: '6px',
                    padding: '0 32px',
                }}
            >
                {isEditMode ? 'Cancel Edit' : 'Edit Form'}
            </Button>

            {isEditMode && (
                <Button
                    type="primary"
                    size="large"
                    htmlType="submit"
                    disabled={isSubmitting}
                    loading={isSubmitting}
                    style={{
                        borderRadius: '6px',
                        padding: '0 32px',
                    }}
                >
                    Save Changes
                </Button>
            )}

            <Button
                type="default"
                size="large"
                onClick={onPrint}
                style={{
                    borderRadius: '6px',
                    padding: '0 32px',
                }}
            >
                Print
            </Button>
        </div>
    );
};
